export const getUpsellIdFallback = (market: string, channel: string) => {
  let upsellPerMarket
  switch (channel) {
    case "softshell":
      upsellPerMarket = {
        AU: "up_6n9b3g16w4bum",
        CA: "up_yh38aoxz523o6",
        CH: "up_f53xikr8mzy7f",
        EU: "up_ojzr1apoe5vr8",
        GB: "up_9frqbgd4akmn0",
        GLOBAL: "up_ojzr1apoe5vr8",
        NZ: "up_9aso5y8dfssxb",
        US: "up_wv358ru3wxmyj",
      }
      break
    case "baerskin-hoodie-4":
      upsellPerMarket = {
        AU: "up_fmdpegk3zvkx5",
        CA: "up_t6lxdf1d193ci",
        CH: "up_p11sey3eaygn1",
        EU: "up_d9wx345m7dt1q",
        GB: "up_b3ezj4nn1gofv",
        GLOBAL: "up_d9wx345m7dt1q",
        NZ: "up_k9f26z0n1dszb",
        US: "up_s9luzfu2n2ogx",
      }
      break
    case "vest":
      upsellPerMarket = {
        AU: "up_dzt0r7ke6pcx6",
        CA: "up_l1afbjveirfrh",
        CH: "up_sgveamxb5nfmg",
        EU: "up_hblobvqsxdy9o",
        GB: "up_qxjpdhotn6d58",
        GLOBAL: "up_hblobvqsxdy9o",
        NZ: "up_tn1tej70wvudu",
        US: "up_s9luzfu2n2ogx",
      }
      break
    case "store":
    default:
      upsellPerMarket = {
        AU: "up_aiazxwe3usqp7",
        CA: "up_inod512s8mex2",
        CH: "up_sqjkh1hgppnb9",
        EU: "up_pzxk5aty9fgem",
        GB: "up_zdbxtovq80ghe",
        GLOBAL: "up_pzxk5aty9fgem",
        NZ: "up_g64f7sgzlymq7",
        US: "up_28cruwkwxn5uf",
      }
      break
  }
  return upsellPerMarket[market.toUpperCase() as keyof typeof upsellPerMarket]
}
